/**
 * Tries to use local edge function if in development, otherwise uses the deployed edge function.
 * NODE_ENV will be set to "development" when running gatsby develop.
 */
export const fetchEdgeFunction = (
	url: string,
	options?: RequestInit,
): Promise<Response> => {
	const developmentResponse: { [key: string]: BodyInit | null | undefined } = {
		// Notice the string, .json() will throw an error if the "" arent part of the returned string.
		"/ip-lookup": '"0.0.0.0"',
		"/country-lookup": JSON.stringify({ code: "SE" }),
	};

	return process.env.NODE_ENV === "development"
		? Promise.resolve(new Response(developmentResponse[url]))
		: fetch(url, options);
};
